"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = conditionallyLoadAnalytics;

var _helpers = require("../../helpers");

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function conditionallyLoadAnalytics(_ref) {
  var writeKey = _ref.writeKey,
      allDestinations = _ref.allDestinations,
      destinationFlags = _ref.destinationFlags,
      isConsentRequired = _ref.isConsentRequired,
      _ref$shouldReload = _ref.shouldReload,
      shouldReload = _ref$shouldReload === void 0 ? true : _ref$shouldReload,
      categoryFlags = _ref.categoryFlags;

  var _reporter = (0, _helpers.reporter)(),
      info = _reporter.info,
      log = _reporter.log,
      table = _reporter.table;

  info('%cconditionallyLoadAnalytics', 'color: cyan; font-weight: bold;'); // return early if analytics not present

  if (!window.analytics) return;

  if (!destinationFlags) {
    // return early if consent is required and none have been given
    if (isConsentRequired) {
      return;
    } // load and execute and return, if consent is not required


    if (!window.analytics.initialized) {
      window.analytics.load(writeKey);
      window.analytics.page();
    }

    return;
  } // build up a list of integration flags


  var integrations = {
    All: false,
    'Segment.io': true
  };
  var isAnythingEnabled = false;

  var _iterator = _createForOfIteratorHelper(allDestinations),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var destination = _step.value;
      var isEnabled = Boolean(destinationFlags[destination.id]);
      if (isEnabled) isAnythingEnabled = true;
      integrations[destination.id] = isEnabled;
    } // if analytics is already loaded, and we have new prefs, we must reload

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (window.analytics.initialized) {
    if (shouldReload) {
      log('reloading due to changed preferences');
      window.location.reload();
    }

    return;
  } // Don't load analytics.js at all if nothing has been enabled!


  if (!isAnythingEnabled) return; // otherwise setup the middleware and do it

  window.analytics.addSourceMiddleware(function (_ref2) {
    var payload = _ref2.payload,
        next = _ref2.next,
        integrations = _ref2.integrations;
    payload.obj.context.consent = {
      destinations: destinationFlags,
      categories: categoryFlags
    };
    next(payload);
  });
  info('%cloading analytics', 'color: orange; font-weight: bold;'); // table(integrations);

  window.analytics.load(writeKey, {
    integrations: integrations
  });
  window.analytics.page();
}